
export default {
  props: {
    active: { type: Boolean, default: false },
    special: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    link: { type: String, default: '' },
    tag: { type: String, default: '' },
  },
  computed: {
    cosmeticClass() {
      if (this.disabled) return 'ebo-button-disabled'
      if (this.active) return 'ebo-button-active'
      if (this.special) return 'ebo-button-special'
      return ''
    },
  },
}
